import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@hobs/components/Tooltip';
import Styles from './InputLabel.module.scss';

const InputLabel = ({ children, indicationMessage, ...props }) => {
  return (
    <span className={Styles.labelWrapper}>
      <label className={Styles.label} {...props}>
        {children}
      </label>
      {indicationMessage && (
        <Tooltip tooltip={indicationMessage} position="top">
          <span className={Styles['history-indication']}></span>
        </Tooltip>
      )}
    </span>
  );
};

InputLabel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string
  ]),
  indicationMessage: PropTypes.object
};

export default InputLabel;
